import Layout from '@/layout'

const villageRouter = {
  path: '/',
  component: Layout,
  children: [
    {
      path: '/demand',
      name: 'demand',
      meta: {
        title: '抢单服务',
      },
      component: () => import('@/views/demand/index.vue'),
    },
    {
      path: '/demand/orderList',
      name: 'orderList',
      meta: {
        title: '订单列表',
      },
      component: () => import('@/views/demand/orderList.vue'),
    },
    {
      path: '/demand/detail/:id',
      name: 'detail',
      meta: {
        title: '需求详情',
      },
      component: () => import('@/views/demand/detail.vue'),
    },
    {
      path: '/demand/orderDetail/:id',
      name: 'orderDetail',
      meta: {
        title: '订单详情',
      },
      component: () => import('@/views/demand/orderDetail.vue'),
    },
    {
      path: '/demand/historyComment/:id',
      name: 'historyComment',
      meta: {
        title: '历史评价',
      },
      component: () => import('@/views/demand/historyComment.vue'),
    },
    {
      path: '/demand/evaluate/:id/:demandId/:userId/:userType',
      name: 'evaluate',
      meta: {
        title: '评价',
      },
      component: () => import('@/views/demand/evaluate.vue'),
    },
    {
      path: '/demand/addDemand',
      name: 'addDemand',
      meta: {
        title: '发布需求',
      },
      component: () => import('@/views/demand/addDemand.vue'),
    },
  ],
}

export default villageRouter
